import { FONT_BASE, LINE_HEIGHT_BASE } from '../themeConstants'

export const muiComponentsForms = {
  MuiTextField: {
    defaultProps: {
      variant: 'standard',
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontFamily: 'inherit',
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE,
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontSize: FONT_BASE,
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontSize: FONT_BASE,
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE,
      },
      label: {
        fontSize: FONT_BASE,
      },
    },
  },
}
